// Smooth-scroll same-page anchor links with sticky-header offset.

export function initSmoothScroll() {
	document.addEventListener('click', (e) => {
		const link = e.target.closest('a[href^="#"]');
		if (!link) return;

		const href = link.getAttribute('href');
		if (!href || href === '#') return;

		const target = document.querySelector(href);
		if (!target) return;

		e.preventDefault();
		const headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--cs-header-h')) || 72;
		const top = target.getBoundingClientRect().top + window.scrollY - headerH - 12;
		window.scrollTo({ top, behavior: 'smooth' });

		if (history.pushState) history.pushState(null, '', href);
	});
}
